import { Flex, Link, Text } from '@chakra-ui/react';
import { ReactComponent as UpgradeIcon } from 'assets/icons/crown_upgrade_fill.svg';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface BusinessUpgradeButtonProps {
  onClickUpgradeModal: () => void;
}
/**
 * Should this be merged in one component
 * TODO similar to frontend/src/modules/Editor/components/WidgetMenu/SideMenu/BrandKitMenu/BrandKitTab/BusinessUpgradeButton.tsx
 * @param BusinessUpgradeButtonProps
 * @returns ReactElement
 */
export const BusinessUpgradeButton = ({ onClickUpgradeModal }: BusinessUpgradeButtonProps): ReactElement => {
  const { t } = useTranslation('common_navbar', { useSuspense: false });

  return (
    <Flex marginBottom={3} flexWrap='wrap' alignItems='center'>
      <UpgradeIcon color='var(--vg-colors-upgrade-700)' />
      <Link
        fontSize='xs'
        color='upgrade.700'
        fontWeight='semibold'
        ml='1'
        lineHeight='1.2'
        onClick={onClickUpgradeModal}
        as='button'
      >
        {t('modals.download.upgrade-business')}
      </Link>
      <Text fontSize='xs' fontWeight='medium' ml='1' lineHeight='1.2'>
        {t('modals.toUseImageFolders')}
      </Text>
    </Flex>
  );
};
